import { render } from "./NewBoxSVA.vue?vue&type=template&id=9a7e0a80"
import script from "./NewBoxSVA.vue?vue&type=script&lang=js"
export * from "./NewBoxSVA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__